import React from 'react';

import {ProcessPlatformFeatureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ProcessClientOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import {
  processExecutionTypeDisplayName,
  getEnabledProcessExecutionTypesForPlatformFeature,
} from 'processes/ProcessConstants';
import {MultiValueFilter} from 'search/SearchConstants';
import pickDefined from 'util/pickDefined';

import DropdownFilterForm, {prefixedToggleText} from './base/DropdownFilterForm';
import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';

interface ProcessExecutionTypeFilterFormProps extends BaseFilterFormProps {
  filter: MultiValueFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: MultiValueFilter) => void;
  onRemove?: () => void;
}

export default function ProcessExecutionTypeFilterForm(
  props: ProcessExecutionTypeFilterFormProps
): JSX.Element {
  const optionDatas = getEnabledProcessExecutionTypesForPlatformFeature(
    ProcessPlatformFeatureType.WORKFLOWS_SEARCH
  ).map((executionType) => ({
    name: processExecutionTypeDisplayName(ProcessClientOrigin.PROCESSES, executionType),
    value: executionType,
  }));
  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  return (
    <DropdownFilterForm
      {...skeletonProps}
      dropdownToggleText={prefixedToggleText('Execution Type', optionDatas, props.filter)}
      optionDatas={optionDatas}
      filterStyle={props.filterStyle}
      isMulti={true}
      isSearchable={false}
      onRemove={props.onRemove}
      value={props.filter.value}
      onChangeValue={(value: Array<string>) => {
        props.onChangeFilter({...props.filter, value});
      }}
    />
  );
}
